import { gql } from '@apollo/client';
import SPECIFICATION from 'api/fragments/SPECIFICATION';
const GET_ALL_SPECIFICATIONS = gql `
  ${SPECIFICATION}
  query GetAllSpecifications(
    $search: String
    $tags: [ID]
    $orderBy: String
    $first: Int
    $after: String
    $state: [String]
    $statusId: [ID]
    $categoryId: [ID]
  ) {
    me {
      id
      currentTenant {
        id
        modelSpecifications(
          search: $search
          tags_TagId: $tags
          orderBy: $orderBy
          first: $first
          after: $after
          isActive: true
          state: $state
          statusId: $statusId
          categoryId: $categoryId
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...SpecificationFragment
            }
          }
        }
      }
    }
  }
`;
export default GET_ALL_SPECIFICATIONS;
